import React from "react";

/**
 * Logo TAH con variante para modo oscuro.
 * En claro: logo normal. En oscuro: la "T", la "H" y el texto inferior
 * pasan a blanco; la casa y la "A" roja se mantienen igual.
 */
export default function BrandLogo({ className = "h-9 w-auto", alt = "Tu Aliado Hostelero", ...props }) {
  return (
    <>
      <img src="/tah-logo.png" alt={alt} width="200" height="79" className={`${className} block dark:hidden`} {...props} />
      <img src="/tah-logo-dark.png" alt={alt} width="200" height="79" className={`${className} hidden dark:block`} {...props} />
    </>
  );
}
